import Keycloak from 'keycloak-js'
import store from '@/store'
import logout from './logout'
import { startIdleTracking, isIdle } from './idle'

const keycloakAuth = new Keycloak('/keycloak.json')

// keycloak-js throws if init() is called twice on the same instance, so keep the first result.
let initPromise = null
let refreshTimer = null

// Keycloak 26 rejects redirect URLs that carry leftover login parameters after '#'.
const cleanUrl = () => window.location.origin + window.location.pathname + window.location.search

export default (next, roles, sso = false) => {
  const auth = store.getters.SECURITY_AUTH

  if (!auth.authenticated && auth.login) {
    auth.login({ redirectUri: cleanUrl() })
    return
  }

  const param = {
    onLoad: sso ? 'check-sso' : 'login-required',
    redirectUri: cleanUrl(),
  }

  if (!initPromise) {
    initPromise = keycloakAuth.init(param)
  }

  initPromise
    .then((authenticated) => {
      store.dispatch('authLogin', keycloakAuth)
      if (authenticated) {
        if (roles) {
          let hasRole = false

          if (keycloakAuth.hasRealmRole('devops')) {
            hasRole = true
          } else {
            for (const role of roles) {
              if (keycloakAuth.hasRealmRole(role)) {
                hasRole = true
                break
              }
            }
          }

          if (hasRole) {
            next()
          } else {
            next({ name: 'Unauthorized' })
          }
        } else {
          next()
        }
        if (!refreshTimer) {
          // UCR item 5: refresh only while the dealer is active; log out after 30 minutes idle.
          startIdleTracking()
          refreshTimer = setInterval(function () {
            if (isIdle()) {
              clearInterval(refreshTimer)
              logout()
              return
            }
            keycloakAuth.updateToken(70)
              .then((refreshed) => {
                refreshed && store.dispatch('authLogin', keycloakAuth)
              })
              .catch(() => {
                location.replace(location.protocol + '//' + location.hostname + '/')
              })
          }, 60000)
          // A sleeping laptop or paused tab may not run the timer on time, so check again when it comes back.
          document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible' && keycloakAuth.authenticated && isIdle()) {
              clearInterval(refreshTimer)
              logout()
            }
          })
        }
      } else {
        next()
      }
    })
    .catch(() => {
      console.log('Failed to login')
      next()
    })
}
